export const RECONSTRUCTION_PROCESS_TYPE = '3D Reconstruction';
